import React, { createContext, useEffect, useState } from "react";
import { localStorageManager } from "@/services/localStorage";
import { LOCAL_STORAGE_BASE_KEYS } from "@/types/v2";

export interface CardMetricsOptionsContextType {
  timestampsEnabled: boolean;
  setTimestampsEnabled: (enabled: boolean) => void;
  aggregateTimesEnabled: boolean;
  setAggregateTimesEnabled: (enabled: boolean) => void;
}

export const CardMetricsOptionsContext = createContext<
  CardMetricsOptionsContextType | undefined
>(undefined);

export const CardMetricsOptionsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [timestampsEnabled, setTimestampsEnabled] = useState<boolean>(() => {
    const savedMode = localStorageManager.getItem(
      LOCAL_STORAGE_BASE_KEYS.CARD_METRICS_TIMESTAMPS_ENABLED
    );
    return savedMode ? savedMode === "1" : false;
  });
  const [aggregateTimesEnabled, setAggregateTimesEnabled] = useState<boolean>(
    () => {
      const savedMode = localStorageManager.getItem(
        LOCAL_STORAGE_BASE_KEYS.CARD_METRICS_AGGREGATE_VIEW
      );
      return savedMode ? savedMode === "1" : false;
    }
  );

  useEffect(() => {
    localStorageManager.setItem(
      LOCAL_STORAGE_BASE_KEYS.CARD_METRICS_TIMESTAMPS_ENABLED,
      timestampsEnabled ? "1" : "0"
    );
  }, [timestampsEnabled]);

  useEffect(() => {
    localStorageManager.setItem(
      LOCAL_STORAGE_BASE_KEYS.CARD_METRICS_AGGREGATE_VIEW,
      aggregateTimesEnabled ? "1" : "0"
    );
  }, [aggregateTimesEnabled]);

  return (
    <CardMetricsOptionsContext.Provider
      value={{
        timestampsEnabled,
        setTimestampsEnabled,
        aggregateTimesEnabled,
        setAggregateTimesEnabled,
      }}
    >
      {children}
    </CardMetricsOptionsContext.Provider>
  );
};
